export default __webpack_public_path__ + "assets/new-zealand-flag.png";